/**
 * Todoオブジェクトを生成する
 * @param {Object} row
 * @returns {import('./Todo').Todo}
 */
export function createTodo(row) {

    return {
        todoId: row.todo_id,
        userId: row.user_id,
        todo: row.todo,

        completedAt: row.completed_at ? new Date(row.completed_at) : null,
        deletedAt: row.deleted_at ? new Date(row.deleted_at) : null,
        createdAt: new Date(row.created_at),
        updatedAt: new Date(row.updated_at),

        isEditing: false,
        originalTodo: row.todo,
    }
}